
export const superAdminTabs = [
  // New Comment
  // {
  //   heading: "Booking Engine",
  //   subheading: ["Flight Ticket", "Flight Booking"],
  // },
  {
    heading: "Agency Management",
    subheading: ["User Management"], // Removing "Add Agency", "View Agency", "View Book", "Ledger",
  },

  // New addition
  {
  heading: "Administration",
  subheading: ["Markup"]
},


  // old comment
  // {
  //   heading: "CRM",
  //   subheading: ["Lead Management"],
  // },

  // New Comment
  // {
     // heading: "Administration",
     // subheading: ["Product List", "Commercial Plans", "Migration", "Supplier Management", "Tax Configuration", "Fare Rule Configuration", "Command Builder", "Location Setting", "Security Management",],
  // },
  // {
  //    heading: "Organization Management",
  //    subheading: ["Organization Staff"]
  // },
  // {
  //    heading: "Role Management",
  //   subheading: ["Role Management", "User Access Unmapping"]
  // },
  {
    heading: "Report",
     subheading: ["Sales Reports"] // Remove "Transaction Report", "Wallet statement", 
  },
    {
    heading: "Finance",
    subheading: ["Performance Sheet", "Customer Statement", "Supplier Statement", "Customer Ledger", "Supplier Ledger"] // "Tour Invoice", "Customer", "Supplier", "GDS", "Travellers",  "View Book"
  },

  // Old comment
  //  {
  //   heading : "Account",
  //   subheading:["ROE","Payment Receipt","Wallet Adjustment"]
  //  },
  //  {
  //   heading : "CMS",
  //   subheading:["Content Pages"]
  //  },
  //  {
  //   heading : "Language management",
  //   subheading:["Languages List","Translation Manager"]
  //  },
  //  {
  //   heading : "Theme",
  //   subheading:["Theme Management"]
  //  },
  //  {
  //   heading : "Notification",
  //   subheading:["Email Trigger Settings"]
  //  }, 


  //  {
  //   heading: "Umrah",
  //   subheading: ["Add Umrah"],
  // },
  //  {
  //   heading: "Transport",
  //   subheading: ["Add Transport"],
  // },
  //  {
  //   heading: "Visa",
  //   subheading: ["Add Visa"],
  // },
  //  {
  //   heading: "Hotel",
  //   subheading: ["Add Hotel"],
  // },
]

export const agencyTabs = [
  {
    heading: "Booking Engine",
    subheading: ["Flight Ticket", "Flight Booking"],
  },
  {
    heading: "Discount / Markups",
    subheading: ["Pricing"] // "Tour Invoice", "Customer", "Supplier", "GDS", "Travellers", 
  },
  {
    heading: "Agency Management",
    subheading: ["View Agency", "User Management"],
  },
  // {
  //   heading: "CRM",
  //   subheading: ["Lead Management"],
  // },
  //  {
  //   heading : "Administration",
  //   subheading: ["Product List", "Commercial Plans" ,"Migration","Supplier Management","Tax Configuration","Fare Rule Configuration","Command Builder","Location Setting","Security Management",],
  //  },
  //  {
  //   heading : "Organization Management",
  //   subheading:["Organization Staff"]
  //  },
  //  {
  //   heading : "Role Management",
  //   subheading:["Role Management","User Access Unmapping"]
  //  },
  {
    heading: "Report",
    subheading: ["Sales Reports"] // Remove "Transaction Report", "Wallet statement", 
  },
  {
    heading: "Finance",
    subheading: ["Performance Sheet", "Customer Statement", "Supplier Statement", "Customer Ledger", "Supplier Ledger"] // "Tour Invoice", "Customer", "Supplier", "GDS", "Travellers",  "View Book"
  },
  // {
  //   heading: "Account Statement",
  //   subheading: ["Customer Statement", "Supplier Statement"]
  // },
  // {
  //   heading: "Ledger",
  //   subheading: ["Customer Ledger"] //, "Supplier Ledger"
  // },
  //  {
  //   heading : "Account",
  //   subheading:["ROE","Payment Receipt","Wallet Adjustment"]
  //  },
  //  {
  //   heading : "CMS",
  //   subheading:["Content Pages"]
  //  },
  //  {
  //   heading : "Language management",
  //   subheading:["Languages List","Translation Manager"]
  //  },
  //  {
  //   heading : "Theme",
  //   subheading:["Theme Management"]
  //  },
  //  {
  //   heading : "Notification",
  //   subheading:["Email Trigger Settings"]
  //  }, 
]



export const saleTabs = [


  // {
  //   heading : "CRM",
  //   subheading: ["Flight Booking", "Lead Management"],
  //  },

  //  {
  //   heading : "Report",
  //   subheading:["Transaction Report","Wallet statement","Customer Statement"]
  //  },
  //  {
  //   heading : "Account",
  //   subheading:["ROE","Payment Receipt","Wallet Adjustment"]
  //  },

  //  {
  //   heading : "Notification",
  //   subheading:["Email Trigger Settings"]
  //  }, 
]

// export const UmrahTabs = [
//   {
//     heading: "Umrah",
//     subheading: ["Add Umrah"],
//   },
  
// ]